export interface CashReportCompanyLookup {
  id: number;
  name: string;
}

interface CashReportCompanyLookupSource {
  id: number;
  name?: string | null;
}

export const mapCompanyToCashReportLookup = (
  company: CashReportCompanyLookupSource
): CashReportCompanyLookup | undefined => {
  const normalizedName = company.name?.trim();
  if (!normalizedName) {
    return undefined;
  }

  return {
    id: company.id,
    name: normalizedName,
  };
};
